import { createFileRoute } from "@tanstack/react-router";
import { NewPostPage } from "#/components/publish/NewPostPage";

// New post (#728): a sibling leaf to Posts with its own canonical URL — see
// `goodsender-autopilot/specs/728-dashboard-nav-reorg/DECISIONS.md` D-728-7.
//
// No `key={workspaceId}` here, unlike `posts/index.tsx`'s `<PublishPage>`:
// `NewPostPage` already keys `PostEditor` — the only state that must not
// survive a workspace switch — on `workspaceId` itself, so keying here would
// just remount the same subtree twice.
export const Route = createFileRoute("/dashboard/w/$workspaceId/posts/new")({
  // The composer takes the whole viewport — no sidebar, no top bar (design
  // §2). The layout reads this; nothing here matches on pathnames.
  staticData: { fullscreen: true },
  component: NewPostRoute,
});

function NewPostRoute() {
  const { workspaceId } = Route.useParams();
  const navigate = Route.useNavigate();
  return (
    <NewPostPage
      workspaceId={workspaceId}
      // A push, not the `replace: true` the old `?new=true` branch used (#728).
      // That flag kept a *search param* out of history; `/posts/new` is a real
      // page, and Close is not the only way off it — every nav link pushes, so
      // replacing here would make "leave the composer" rewrite history
      // differently depending on which control the reader used.
      onClose={() =>
        void navigate({
          to: "/dashboard/w/$workspaceId/posts",
          params: { workspaceId },
        })
      }
    />
  );
}
